import { AxiosRequestConfig, RawAxiosRequestHeaders } from 'axios';
import { getToken } from 'firebase/app-check';

import { inMemoryJWTService } from './jwt.service';

import { firebaseAppCheck } from '~configs/firebase';

export type GetParams<T> = {
  path: string;
  config?: AxiosRequestConfig;
  customHeader?: RawAxiosRequestHeaders;
  applyMiddleWare?: boolean;
  params?: T;
  ignoreAuthHeader?: boolean;
  includeAppCheckHeader?: boolean;
};

export type PostParams<T> = GetParams<T> & {
  data?: T;
};

export const getAuthHeader = async (options?: {
  ignoreAuthHeader?: boolean;
  includeAppCheckHeader?: boolean;
}): Promise<RawAxiosRequestHeaders> => {
  const headers: RawAxiosRequestHeaders = {};

  if (!options?.ignoreAuthHeader) {
    const authToken = await inMemoryJWTService.getValidToken();
    headers['Authorization'] = `Bearer ${authToken}`;
  }

  if (options?.includeAppCheckHeader && firebaseAppCheck) {
    try {
      const appCheckTokenResult = await getToken(
        firebaseAppCheck,
        /* forceRefresh= */ false,
      );
      headers['X-Firebase-AppCheck'] = appCheckTokenResult.token;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('Failed to get App Check token', error);
    }
  }

  return headers;
};
